import React from 'react'
import { TextAreas, findadminvalue, interestProject } from '../project'
import { motion } from 'framer-motion'
import { FiTrash2 } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { FaUser, FaMapMarkerAlt, FaPhoneAlt, FaInfoCircle } from 'react-icons/fa'

function Projectsbox({ value, userId, array, arrayfunc, admin, my, deleteProjects }) {
    const item = {
        hidden: { y: 400, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
        },
    }

    const interestbtn = () => {
        interestProject(value.id, userId).then(function (response) {
            if (response.data) {
                arrayfunc((prevData) => [...prevData, { projectNum: value.id, userId: userId }])
                Swal.fire('즐겨찾기에서 추가되었습니다.', 'success')
            } else {
                const updatedInterest = array.filter((item) => item.projectNum !== value.id)
                arrayfunc(updatedInterest)
                Swal.fire('즐겨찾기에서 삭제되었습니다.', 'success')
            }
        })
    }

    // ✅ minicate 방어 (null, 문자열, 이상한 값 등)
    let safeMinicate = []
    if (value && Array.isArray(value.minicate)) {
        safeMinicate = value.minicate
    } else if (value && typeof value.minicate === 'string' && value.minicate.trim() !== '') {
        try {
            const parsed = JSON.parse(value.minicate)
            safeMinicate = Array.isArray(parsed) ? parsed : []
        } catch (e) {
            safeMinicate = []
        }
    }

    // ✅ 주소 방어 (null 등)
    function getClientAddress(address) {
        if (typeof address !== 'string') return ''
        const addressArray = address.split(' ')
        const 시구주소 = addressArray.slice(0, 2).join(' ')
        return 시구주소
    }

    // ✅ 결재 상태용 adminstatus 값도 안전하게 추출
    let adminStatusValue = null
    if (value && typeof findadminvalue === 'function') {
        const info = findadminvalue(value.adminstatus)
        if (info && info.value !== undefined && info.value !== null) {
            const num = Number(info.value)
            if (!isNaN(num)) {
                adminStatusValue = num
            }
        }
    }

    return (
        <>
            {value ? (
                <motion.li className="pro_box li" variants={item}>
                    <div className="pro_box_in flex centerj">
                        {/* 상단 제목 영역 */}
                        <div className="flex l a j">
                            <div className="flex a">
                                {/* <div className="navi_round_tag">{value.adminstatus}</div> */}
                                <div className="navi_round_tag">
                                    {value.adminstatus === '완료보고서' ? '3단계 개발' : value.adminstatus}
                                </div>
                                <div className="box_title ml20">
                                    {my ? (
                                        <Link to={`?uid=${value.uid}`}>{value.title}</Link>
                                    ) : admin ? (
                                        <Link to={`?uid=${value.uid}`}>{value.title}</Link>
                                    ) : (
                                        <a href={`/Projects/list/${value.uid}`}>{value.title}</a>
                                    )}
                                </div>
                                {value.adminstatus === '임시저장' && my ? (
                                    <button onClick={(e) => deleteProjects(value.uid)} className="xbtnstyle ml10">
                                        <FiTrash2 className="f20 " />
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>

                            <div className="pro_updatetime">
                                <div>등록일자 : {value.createdtime}</div>
                                <div>수정일자 : {value.updatetime}</div>
                            </div>
                        </div>

                        {/* 카테고리 / 미니카테고리 */}
                        <div className="flex l a">
                            <div className="w_round_tag_b ">
                                <span>{value.cate}</span>
                            </div>
                            <div className="flex w_round_tag ml20">
                                {safeMinicate.map((m) => (
                                    <span key={m}>{m}</span>
                                ))}
                            </div>
                        </div>

                        {/* 금액 / 기간 / 회의 방식 / 진행상태 / 결재상태 */}
                        <div className="box_width_tag blue flex a">
                            <div className="flex a">
                                <span className="tagT mr10">예상 금액</span>
                                <span className="bar mr10"></span>
                                <span>{value.price}원</span>
                            </div>
                            <div className="flex a">
                                <span className="tagT mr10">예상 기간</span>
                                <span className="bar mr10"></span>
                                <span>{value.term}</span>
                            </div>
                            <div className="flex a">
                                <span className="tagT mr10">회의 방식</span>
                                <span className="bar mr10"></span>
                                <span>
                                    {value.meet === 'on'
                                        ? '온라인'
                                        : value.meet === 'off'
                                        ? '오프라인'
                                        : value.meet === 'onoff'
                                        ? '온오프라인'
                                        : ''}
                                </span>
                            </div>
                            <div className="flex a">
                                <span className="mr10">진행 상태</span>
                                <span className="bar mr10"></span>
                                <span>
                                    {value.pStatus === 'new'
                                        ? '신규'
                                        : value.pStatus === 'better'
                                        ? '개선'
                                        : value.pStatus === 'ing'
                                        ? '유지보수'
                                        : ''}
                                </span>
                            </div>

                            {/* ✅ 결재 상태: adminStatusValue가 제대로 있을 때만 표시 */}
                            <div className="flex a">
                                {adminStatusValue !== null && adminStatusValue >= 8 ? (
                                    <div className="flex a">
                                        <span className="mr10">결재 상태</span>
                                        <span className="bar mr10"></span>
                                        <span>
                                            {adminStatusValue <= 8
                                                ? '선금대기'
                                                : adminStatusValue <= 9
                                                ? '선금완료'
                                                : adminStatusValue <= 10
                                                ? '중도금대기'
                                                : adminStatusValue <= 11
                                                ? '중도금완료'
                                                : adminStatusValue <= 13
                                                ? '잔금대기'
                                                : adminStatusValue <= 14
                                                ? '잔금완료'
                                                : ''}
                                        </span>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>

                        {/* 본문 영역 */}
                        <div className="pro_body_b flex j a">
                            <div className="w80_ flex j a">
                                <div className="w50 navi_border_left p10">
                                    <h1>프로젝트 개요</h1>
                                    <div className="pro_subtext">
                                        <TextAreas value={value.outline} />
                                    </div>
                                </div>
                                <div className="w50 navi_border_left p10">
                                    <h1>최종 산출물</h1>
                                    <div className="pro_subtext">
                                        <TextAreas value={value.lastprojects} />
                                    </div>
                                </div>
                            </div>
                            <div className="w20_ navi_border_left p10">
                                <h1 className="flex a">
                                    <FaInfoCircle className="mr10" />
                                    <span>담당자 정보</span>
                                </h1>
                                <div className="pro_subtext">
                                    <p>
                                        <FaUser className="mr10" />
                                        <span>담당자 : {value.client}</span>
                                    </p>
                                    <p>
                                        <FaMapMarkerAlt className="mr10" />
                                        <span>주소지 : {getClientAddress(value.clientaddress)}</span>
                                    </p>
                                    <p>
                                        <FaPhoneAlt className="mr10" />
                                        <span>연락처 : {value.clientphone ? value.clientphone : ''}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.li>
            ) : (
                ''
            )}
        </>
    )
}

export default Projectsbox
